import { render } from "./nanamota-hero.vue?vue&type=template&id=5f2ef32e&scoped=true"
import script from "./nanamota-hero.vue?vue&type=script&lang=js"
export * from "./nanamota-hero.vue?vue&type=script&lang=js"

import "./nanamota-hero.vue?vue&type=style&index=0&id=5f2ef32e&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f2ef32e"]])

export default __exports__